// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
tr.sub-table-row td {
  background-color: rgba(28, 115, 186, 0.1) !important;
}

@media (max-width: 1366px) {
  :host ::ng-deep .p-datatable .p-datatable-tbody tr th {
    padding: 12px 8px;
  }
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td {
  width: 15%;
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td:first-child {
  width: 20%;
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td:last-child {
  width: 10%;
}
@media (max-width: 1366px) {
  :host ::ng-deep .p-datatable .p-datatable-tbody tr td {
    width: 14.5%;
    padding: 12px 8px;
  }
  :host ::ng-deep .p-datatable .p-datatable-tbody tr td:first-child {
    width: 19%;
    overflow-wrap: anywhere;
  }
  :host ::ng-deep .p-datatable .p-datatable-tbody tr td:last-child {
    width: 8.5%;
  }
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td .gc-agency-handle {
  width: 160px;
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td.leftBoder-4 {
  border-left: 4px solid #0A6ED9 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
